import * as React from 'react';

const Flag16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M1.75 0a.75.75 0 0 1 .75.75V1h11.751a.75.75 0 0 1 .566 1.242l-3.095 3.812 3.121 3.736a.75.75 0 0 1-.592 1.21H2.5v4.25a.75.75 0 0 1-1.5 0V.75A.75.75 0 0 1 1.75 0m.75 9.5h10.218l-2.559-3.012a.75.75 0 0 1 .026-.952L12.718 2.5H2.5z"
  }
));
Flag16.Size = 16;
Flag16.Title = "Flag";

export { Flag16 as default };
